import React from "react"
import useT from "../hooks/useT"
import LegalPage from "./LegalPage"
import en from "../legal/en/product-returns.md?raw"
import bg from "../legal/bg/vrashtane-na-produkti.md?raw"

const TEXTS = { en, bg }

export default function ReturnsPage() {
  const t = useT()
  return <LegalPage title={t`Returns Policy`} texts={TEXTS} />
}
